module.exports = __webpack_public_path__ + "img/shb.1787f1d2.jpg";